import type { ReactElement } from 'react'
import { Loader2 } from 'lucide-react'

interface Props {
  visible: boolean
}

/**
 * Glass pill shown over the camera viewfinder while a verify_capture round
 * trip is in flight. Mirrors the caption pill's styling so the chrome
 * reads as one consistent overlay. Renders nothing when `visible` is false.
 */
export const VerifyingIndicator = ({ visible }: Props): ReactElement | null => {
  if (!visible) return null
  return (
    <div className="inline-flex items-center gap-2 bg-primary/80 backdrop-blur-md text-primary-foreground text-sm px-4 py-2 rounded-full mt-2 transition-opacity duration-200">
      <Loader2 className="h-4 w-4 animate-spin" />
      <span>Checking the photo…</span>
    </div>
  )
}
